import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: boosted-listing flash on product cards; the path lives in `IconSprite`. */
export const IconStateZap = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.zap}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
